export default "__VITE_ASSET__3d1f22fb__"